var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding07 = function SvgBuilding07(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.577 21.25V6.712h4.308V2.404h10.23v8.615h4.308V21.25h-8.077v-4.308h-2.692v4.308zm1.616-1.615h2.692v-2.693H4.193zm0-4.308h2.692v-2.692H4.193zm0-4.308h2.692V8.327H4.193zM8.5 15.327h2.692v-2.692H8.5zm0-4.308h2.692V8.327H8.5zm0-4.307h2.692V4.019H8.5zm4.308 8.615H15.5v-2.692h-2.692zm0-4.308H15.5V8.327h-2.692zm0-4.307H15.5V4.019h-2.692zm4.308 12.923h2.692v-2.693h-2.692zm0-4.308h2.692v-2.692h-2.692z"
  })));
};
export default SvgBuilding07;